"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Forms/Import/UploadDialog.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactdropzone = require('react-dropzone'); var _reactdropzone2 = _interopRequireDefault(_reactdropzone);


var _forms = require('shared/services/forms');
var _Modal = require('web/components/Modal'); var _Modal2 = _interopRequireDefault(_Modal);

var _common = require('../common');


var _importRules = require('./importRules');

var _pages = require('./pages');
var _icons = require('../icons');
















const pageName = (name, page) => `${_importRules.formNameOf.call(void 0, name) || 'form'}-page-${page}.jpg`

/* Screen 3: upload a PDF or a photo of a page. Each page becomes a JPEG,
 * goes up through direct upload, and ImportForm makes the draft from them,
 * with a fillable PDF's own fields. */
const UploadDialog = ({ isOpen, orgKey, onClose, onImported }) => {
  const dropzoneRef = _react.useRef(null)
  const [working, setWorking] = _react.useState(null)
  const [error, setError] = _react.useState(null)
  const isMounted = _react.useRef.call(void 0, true)
  _react.useEffect.call(void 0, () => () => { isMounted.current = false }, [])

  _react.useEffect.call(void 0, () => {
    if (isOpen) return
    setWorking(null)
    setError(null)
  }, [isOpen])

  const importFile = async (file) => {
    const kind = _importRules.importKind.call(void 0, file)
    if ('refusal' in kind) {
      setError(kind.refusal)
      return
    }
    setError(null)
    const progress = (pages, uploaded) => {
      if (isMounted.current) setWorking({ fileName: file.name, kind: kind.kind, pages, uploaded })
    }
    progress(0, 0)
    try {
      let pageKeys
      let fields = []
      if (kind.kind === 'pdf') {
        const { openPdf } = await import('./pdf')
        const pdf = await openPdf(file).catch(() => null)
        if (!pdf) throw new Refusal(_importRules.unreadablePdf.call(void 0, file.name))
        try {
          if (pdf.pageCount > _importRules.MAX_PAGES) throw new Refusal(_importRules.tooManyPages.call(void 0, file.name, pdf.pageCount))
          let uploaded = 0
          progress(pdf.pageCount, 0)
          const uploads = []
          const widgets = []
          // Each page uploads while the next one renders.
          for (let i = 0; i < pdf.pageCount; i++) {
            const page = await pdf.renderPage(i)
            widgets.push(page.widgets)
            uploads.push(_pages.uploadPage.call(void 0, page.jpeg, pageName(file.name, i + 1)).then(key => {
              progress(pdf.pageCount, ++uploaded)
              return key
            }))
          }
          pageKeys = await Promise.all(uploads)
          fields = _importRules.widgetsToFields.call(void 0, widgets)
        } finally {
          pdf.close()
        }
      } else {
        const jpeg = await _pages.photoToJpeg.call(void 0, file).catch(() => null)
        if (!jpeg) throw new Refusal(_importRules.unreadablePhoto.call(void 0, file.name))
        progress(1, 0)
        pageKeys = [await _pages.uploadPage.call(void 0, jpeg, pageName(file.name, 1))]
        progress(1, 1)
      }
      const { Form } = await _forms.importForm.call(void 0, { OrgKey: orgKey, Name: _importRules.formNameOf.call(void 0, file.name), PageFileKeys: pageKeys, Fields: fields })
      if (isMounted.current) onImported(Form)
    } catch (e) {
      if (!isMounted.current) return
      setError(e instanceof Refusal ? e.message : _forms.formsErrorText.call(void 0, e, `${file.name} couldn't be uploaded. Try again.`))
    } finally {
      if (isMounted.current) setWorking(null)
    }
  }

  const onDrop = (files) => {
    const [file] = files
    if (file && !working) importFile(file)
  }
  const openPicker = () => { if (!working) _optionalChain([dropzoneRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.open, 'call', _3 => _3()]) }

  return (
    _react2.default.createElement(_Modal2.default, {
      isOpen: isOpen,
      title: "Upload a form"  ,
      className: "forms-upload",
      onClose: working ? undefined : onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}

      , _react2.default.createElement('div', {
        role: "button",
        tabIndex: 0,
        'aria-label': "Choose a file"  ,
        'aria-disabled': !!working,
        className: "forms-upload--drop",
        onClick: openPicker,
        onKeyDown: e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openPicker() } }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 117}}

        , _react2.default.createElement(_reactdropzone2.default, {
          ref: dropzoneRef,
          className: "forms-upload--dropzone",
          disabled: !!working,
          disableClick: true,
          inputProps: { multiple: false },
          onDrop: onDrop, __self: this, __source: {fileName: _jsxFileName, lineNumber: 126}}
        )
        , _react2.default.createElement(_icons.UploadIcon, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 134}} )
        , _react2.default.createElement('span', { className: "forms-upload--drop-title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 135}}, "Drop a file here, or "
               , _react2.default.createElement('span', { className: "forms-upload--link", __self: this, __source: {fileName: _jsxFileName, lineNumber: 136}}, "choose one" )
        )
        , _react2.default.createElement('span', { className: "forms-upload--drop-hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 138}}, "PDF, or a photo of the page. Up to "         ,  _importRules.MAX_PAGES , " pages." )
      )

      ,  working && (
        _react2.default.createElement('div', { className: "forms-upload--file", 'aria-live': "polite", __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}
          , _react2.default.createElement('span', { className: `forms-upload--file-icon forms-upload--file-icon-${working.kind}`, __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}}
            ,  working.kind === 'pdf' ? 'PDF' : 'JPG' 
          )
          , _react2.default.createElement('span', { className: "forms-upload--file-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 146}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 147}},  working.fileName )
            , _react2.default.createElement('span', { className: "forms-upload--file-meta", __self: this, __source: {fileName: _jsxFileName, lineNumber: 148}}
              ,  working.pages ? `${_common.pluralize.call(void 0, working.pages, 'page', 'pages')} · uploading` : 'Reading…' 
            )
            , _react2.default.createElement('span', { className: "forms-progress", __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}
              , _react2.default.createElement('span', { style: { width: `${working.pages ? (working.uploaded / working.pages) * 100 : 5}%` }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}} )
            )
          )
        )
      )

      ,  error && (
        _react2.default.createElement('div', { role: "alert", className: "forms-upload--error", __self: this, __source: {fileName: _jsxFileName, lineNumber: 159}}
          , _react2.default.createElement('span', { 'aria-hidden': "true", className: "forms-upload--error-icon", __self: this, __source: {fileName: _jsxFileName, lineNumber: 160}}, "!")
          , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 161}},  error )
        )
      )

      , _react2.default.createElement('p', { className: "forms-upload--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 165}}, "A fillable PDF keeps its own fields. For anything else, place fields or use Auto-detect."

      )
    )
  )
}

/* A refusal whose message is shown as it is. */
class Refusal extends Error {}

exports. default = UploadDialog
